import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCartCount, removeFromCart, transferTempCartToUser } from "../redux/cartSlice";
import { removeCart } from "../redux/cartSlice";
import { logout, login } from "../redux/authSlice";
import {
  Drawer,
  TextField,
  Typography,
  Button,
  Badge,
  Box,
  ClickAwayListener,
  IconButton,
  FormGroup,
  InputAdornment,
} from "@mui/material";
import logo from "../assets/images/logo.svg";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { jwtDecode } from "jwt-decode";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import showToast from "../components/Toast/Toaster";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import "./Header.css";
import AxiosInstance from "../Axiosinstance";
import { fetchUserData, resetUserState } from "../redux/userSlice";
import SearchIcon from "@mui/icons-material/Search";
import WhiteLoader from "../components/Loader/whiteloader";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DiamondIcon from "@mui/icons-material/Diamond";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import LinkIcon from "@mui/icons-material/Link";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import RedeemIcon from "@mui/icons-material/Redeem";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./JewelleryMegaMenu.css";
import earringsImg from "../assets/images/earing.webp";
import necklacesImg from "../assets/images/necklace.webp";
import braceletsImg from "../assets/images/bracelette.webp";
import ringsImg from "../assets/images/ring.webp";
import broochesImg from "../assets/images/brooches.webp";
import HistoryIcon from "@mui/icons-material/History";
import rings from "../assets/images/rings (1).svg";
import bracelete from "../assets/images/bracelet.svg";
import chain from "../assets/images/chain.svg";
import choker from "../assets/images/choker (1).svg";
import cufflinks from "../assets/images/cufflinks.svg";
import earrings from "../assets/images/earrings.svg";
import gemstone from "../assets/images/gemstone.svg";
import giftset from "../assets/images/gift.svg";
import necklace from "../assets/images/necklace.svg";
import wedding1 from "../assets/images/wedding1.svg";
import watch from "../assets/images/watch.svg";
import ster from "../assets/images/diamond-pendant.svg";
import cardring from "../assets/images/card-ring.svg";
import cardpendant from "../assets/images/card-pendant.svg";
import cardnecklace from "../assets/images/card-necklace.svg";
import cardbracelet from "../assets/images/card-barclet.svg";
import cardearring from "../assets/images/card-earrings.svg";
import cardwedding from "../assets/images/wedding.svg";

// Improved JewelleryNavIcon: beads form a 'U' shape, color prop for stroke
const JewelleryNavIcon = (props) => {
  const color = props.color || "#C9A236";
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: 7, verticalAlign: "middle", ...props.style }}
    >
      <g
        stroke={color}
        strokeWidth="4"
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        {/* Stand base */}
        <ellipse cx="32" cy="58" rx="18" ry="4" />
        {/* Stand body */}
        <path d="M12 20 Q32 4 52 20 Q52 44 32 58 Q12 44 12 20 Z" />
        {/* Necklace beads - U shape */}
        <circle cx="32" cy="28" r="3" />
        <circle cx="25" cy="32" r="3" />
        <circle cx="39" cy="32" r="3" />
        <circle cx="20" cy="40" r="3" />
        <circle cx="44" cy="40" r="3" />
        <circle cx="25" cy="48" r="3" />
        <circle cx="39" cy="48" r="3" />
      </g>
    </svg>
  );
};

// Map product type names to Home category icons
const homeCategoryIconMap = {
  RING: rings,
  "ENGAGEMENT RING": rings,
  BRACELET: bracelete,
  CHAIN: chain,
  CHOCKER: choker,
  CUFFLINKS: cufflinks,
  EARRING: earrings,
  GEMSTONE: gemstone,
  "GIFT SET": giftset,
  NECKLACES: necklace,
  WEDDING: wedding1,
  WATCH: watch,
  STERLING: ster,
};

const Header = () => {
  const baseUrl = process.env.REACT_APP_BASE_API;
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userId, setUserId] = useState(null);
  const [cartopen, setCartOpen] = useState(false);
  const userIds = useSelector((state) => state.auth?.user?.UserId);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const cartCount = useSelector((state) => state.cart.cartCount);
  const cartData = useSelector((state) => state.cart.cartData);
  const [searchOpen, setSearchOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const Mails = useSelector((state) => state.userSlice.userData?.PrimaryEmail);
  const userNames = useSelector((state) => state.userSlice?.userData?.Username);
  // Fixed cartTotal calculation
  const cartTotal = cartData.reduce((total, item) => {
    const diamondPrice = item?.diamondDetails?.Amount || 0;
    const jewelleryPrice = item?.jewellaryAmount
      ? parseFloat(item.jewellaryAmount) || 0
      : 0;
    return total + diamondPrice + jewelleryPrice;
  }, 0);
  // const cartTotal = cartData.reduce((total, item) => {
  //   const diamondPrice = item?.diamondDetails?.Amount || 0;
  //   const jewelleryPrice = item?.matchedChild
  //     ? (item.matchedChild.MakingCharges || 0) + (item.matchedChild.RadiantCharges || 0)
  //     : 0;
  //   return total + diamondPrice + jewelleryPrice;
  // }, 0);
  const handleLogout = () => {
    dispatch(logout());
    dispatch(removeCart());
    dispatch(resetUserState());
    // Clear temporary user ID if it exists
    localStorage.removeItem("tempUserId");
    navigate("/login");
  };

  const checkUserToken = () => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded.UserId);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  };

  useEffect(() => {
    // Fetch cart count for both logged-in users and temporary users
      dispatch(fetchCartCount(userId));
  }, [dispatch, userId]);

  // Also fetch cart on component mount
  useEffect(() => {
    dispatch(fetchCartCount(userId));
  }, [dispatch]);

  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    if (userId) {
      dispatch(fetchUserData(userId));
    }
  }, [dispatch, userId, user, token]);

  useEffect(() => {
    checkUserToken();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const formik = useFormik({
    initialValues: {
      Username: "",
      UserPassword: "",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
      Username: Yup.string().required("Email is required"),
      UserPassword: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      setLoader(true);
      const res = await AxiosInstance.post(`${baseUrl}/user/login`, {
        ...values,
      });
      if (res.data.statusCode === 200) {
        const { token, user } = res.data;
        if (token) {
          const decodedToken = JSON.parse(atob(token.split(".")[1]));
          const expiryTime = decodedToken.exp * 1000 - Date.now();
          setTimeout(() => {
            handleLogout();
          }, expiryTime);
        }
        await dispatch(login({ user, token }));
        
        // Check if there's a temporary cart to transfer
        const tempUserId = localStorage.getItem("tempUserId");
        if (tempUserId) {
          // Transfer temporary cart to real user
          await dispatch(transferTempCartToUser(tempUserId, user.UserId));
          // Clean up temporary user ID
          localStorage.removeItem("tempUserId");
        } else {
          // Just fetch cart count for the logged-in user
        dispatch(fetchCartCount(user.UserId));
        }
        
        showToast.success(res.data.message, { autoClose: 3000 });
        formik.resetForm();
        navigate("/");
        setOpen(false);
      } else {
        showToast.error(res.data.message);
      }
    } catch (error) {
      showToast.error(error.response?.data.message || "An error occurred");
    } finally {
      setLoader(false);
    }
  };

  const id = userId;

  const handleRemoveItem = (AddToCartId) => {
    dispatch(removeFromCart(AddToCartId, id, userId));
  };

  const location = useLocation();
  const searchFormik = useFormik({
    initialValues: { CertificateNo: "" },
    validationSchema: Yup.object({
      CertificateNo: Yup.string()
        // .matches(/^\d+$/, "Only numeric values are allowed.")
        .required("Search by Stock Id number or by Product Name"),
    }),
    onSubmit: (values, { resetForm }) => {
      handleSearchSubmit(values.CertificateNo, resetForm);
    },
  });

  const handleInput = (event) => {
    searchFormik.setFieldValue("CertificateNo", event.target.value);
  };

  const handleSearchSubmit = async (certificateNo, resetForm) => {
    try {
      const response = await AxiosInstance.get(
        `${baseUrl}/stock/searchdata/${certificateNo}`
      );
      if (response.data.statusCode === 200 && response.data.data.length > 0) {
        const item = response.data.data[0];
        showToast.success("Product found successfully");

        // Check if it's a jewellery item or diamond
        if (item.source === "jewellery") {
          // Slugify the product name for the URL
          const slug = (item.ProductName || "")
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
          navigate(`/jewellery/${slug}?id=${item.ProductId}`);
        } else {
          navigate(`/diamonddetail/${item.SKU}`);
        }
      } else {
        showToast.error("No product found with this number.");
      }
    } catch (err) {
      showToast.error("No product found with this search number.");
    } finally {
      resetForm();
      setSearchOpen(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      searchFormik.handleSubmit();
    }
  };

  // const [jewelleryMenuOpen, setJewelleryMenuOpen] = useState(false);
  // const [selectedSidebar, setSelectedSidebar] = useState(0);
  // const [timeoutId, setTimeoutId] = useState(null);

  // const sidebarItems = [
  //   { label: "Bracelet", icon: <EmojiEventsIcon /> },
  //   { label: "Rings", icon: <FavoriteBorderIcon /> },
  //   { label: "Chain", icon: <AllInclusiveIcon /> },
  //   { label: "Chocker", icon: <StarBorderIcon /> },
  //   { label: "Cufflinks", icon: <LinkIcon /> },
  //   { label: "Earrings", icon: <RedeemIcon /> },
  //   { label: "Gemstone", icon: <DiamondIcon /> },
  //   { label: "Gift Set", icon: <CardGiftcardIcon /> },
  //   { label: "Necklace", icon: <DiamondIcon /> },
  // ];

  // const columns = [
  //   {
  //     image: braceletsImg,
  //     title: "BRACELETS",
  //     items: [
  //       "Bangles",
  //       "Cuffs",
  //       "Charm Bracelets",
  //       "Tennis Bracelets",
  //       "Beaded Bracelets",
  //       "Chain Bracelets",
  //       "Wrap Bracelets",
  //       "Stretch Bracelets",
  //       "Ankle Bracelets",
  //     ],
  //     viewAll: "#",
  //   },
  //   {
  //     image: ringsImg,
  //     title: "RINGS",
  //     items: [
  //       "Engagement Rings",
  //       "Wedding Bands",
  //       "Dangles",
  //       "Stackable Rings",
  //       "Signet Rings",
  //       "Solitaire",
  //       "Halo Rings",
  //       "Cluster Rings",
  //       "Cocktail Rings",
  //     ],
  //     viewAll: "#",
  //   },
  //   {
  //     image: necklacesImg,
  //     title: "CHAIN",
  //     items: [
  //       "Chains",
  //       "Pendants",
  //       "Chokers",
  //       "Lariats",
  //       "Necklaces",
  //       "Collar",
  //       "Rope",
  //       "Y-Necklaces",
  //       "Bib",
  //     ],
  //     viewAll: "#",
  //   },
  //   {
  //     image: necklacesImg,
  //     title: "CHOCKER",
  //     items: ["Choker", "Collar", "Bib", "Y-Necklaces", "Rope"],
  //     viewAll: "#",
  //   },
  //   {
  //     image: necklacesImg,
  //     title: "CUFFLINKS",
  //     items: [
  //       "Classic Cufflinks",
  //       "Novelty Cufflinks",
  //       "Silk Knot Cufflinks",
  //       "Chain Link Cufflinks",
  //     ],
  //     viewAll: "#",
  //   },
  //   {
  //     image: earringsImg,
  //     title: "EARRINGS",
  //     items: [
  //       "Studs",
  //       "Hoops",
  //       "Chandelier",
  //       "Dangles",
  //       "Ear Cuffs",
  //       "Huggies",
  //       "Threader",
  //       "Jackets",
  //       "Crawlers",
  //     ],
  //     viewAll: "#",
  //   },
  //   {
  //     image: broochesImg,
  //     title: "GEMSTONE",
  //     items: [
  //       "Ruby",
  //       "Emerald",
  //       "Sapphire",
  //       "Diamond",
  //       "Opal",
  //       "Topaz",
  //       "Amethyst",
  //     ],
  //     viewAll: "#",
  //   },
  //   {
  //     image: broochesImg,
  //     title: "GIFT SET",
  //     items: ["Anniversary Set", "Wedding Set", "Birthday Set", "Festive Set"],
  //     viewAll: "#",
  //   },
  //   {
  //     image: necklacesImg,
  //     title: "NECKLACE",
  //     items: [
  //       "Pendant Necklace",
  //       "Chain Necklace",
  //       "Bib Necklace",
  //       "Collar Necklace",
  //       "Choker Necklace",
  //     ],
  //     viewAll: "#",
  //   },
  // ];

  // const handleJewelleryItemClick = async (
  //   e,
  //   productTypeName,
  //   productSubTypeName
  // ) => {
  //   e.preventDefault();
  //   if (!userIds) {
  //     showToast.warning("Please login to view Jewellery.");
  //     setJewelleryMenuOpen(false);
  //     return;
  //   }
  //   try {
  //     setLoader(true);
  //     const response = await AxiosInstance.post(
  //       `${baseUrl}/diamond-ring/getallproducts`,
  //       {
  //         ProductTypeName: productTypeName.toUpperCase(),
  //         ProductSubTypeName: productSubTypeName.toUpperCase(),
  //       }
  //     );
  //     if (response.data.statusCode === 200) {
  //       showToast.success("Products fetched successfully");
  //       navigate("/jewellery", {
  //         state: {
  //           products: response.data.data,
  //           totalCount: response.data.totalCount,
  //         },
  //       });
  //     } else {
  //       showToast.error(response.data.message || "No products found");
  //       navigate("/jewellery", { state: { products: [], totalCount: 0 } });
  //     }
  //   } catch (error) {
  //     showToast.error(
  //       error.response?.data.message || "Failed to fetch products"
  //     );
  //     navigate("/jewellery", { state: { products: [], totalCount: 0 } });
  //   } finally {
  //     setLoader(false);
  //     setJewelleryMenuOpen(false);
  //   }
  // };
  const handleJewelleryItemClick = async (
    e,
    productTypeName,
    productSubTypeName
  ) => {
    e.preventDefault();
    navigate(
      `/jewellery?productTypeName=${encodeURIComponent(
        productTypeName
      )}&productSubTypeName=${encodeURIComponent(productSubTypeName)}`
    );
    setJewelleryMenuOpen(false);
  };

  const handleMouseEnter = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setJewelleryMenuOpen(true);
  };

  const handleMouseLeave = () => {
    const id = setTimeout(() => {
      setJewelleryMenuOpen(false);
    }, 300);
    setTimeoutId(id);
  };

  // const handleSidebarClick = (idx) => {
  //   setSelectedSidebar(idx);
  // };
  const iconMap = {
    NECKLACE: <DiamondIcon />,
    PENDANT: <RedeemIcon />,
    BRACELETS: <EmojiEventsIcon />,
    Rings: <FavoriteBorderIcon />,
    Chain: <AllInclusiveIcon />,
    Chocker: <StarBorderIcon />,
    Cufflinks: <LinkIcon />,
    EARRINGS: <RedeemIcon />,
    Gemstone: <DiamondIcon />,
    "Gift Set": <CardGiftcardIcon />,
  };

  // Image mapping for column items
  const imageMap = {
    NECKLACES: cardnecklace,
    PENDANT: cardpendant,
    BRACELET: cardbracelet,
    Rings: cardring,
    Chain: necklacesImg,
    Chocker: necklacesImg,
    Cufflinks: necklacesImg,
    EARRING: cardearring,
    WEDDING: cardwedding,
    Gemstone: broochesImg,
    "Gift Set": broochesImg,
    "ENGAGEMENT RING": cardring,
  };
  // State for dynamic sidebar and column items
  const [sidebarItems, setSidebarItems] = useState([]);
  const [columnItems, setColumnItems] = useState([]);
  const [selectedSidebar, setSelectedSidebar] = useState(0);
  const [jewelleryMenuOpen, setJewelleryMenuOpen] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  // Add mobile jewellery menu state
  const [mobileJewelleryOpen, setMobileJewelleryOpen] = useState(false);

  const fetchSidebarItems = async () => {
    try {
      const response = await AxiosInstance.get(
        `${baseUrl}/producttype/getallproducttypesnames`
      );
      if (response.data.message === "Product Types retrieved successfully") {
        // Define the desired order with a Map for O(1) lookup
        const desiredOrder = new Map([
          ["ENGAGEMENT RING", 0],
          ["EARRING", 1], 
          ["NECKLACES", 2],
          ["BRACELET", 3],
          ["WEDDING", 4]
        ]);
        
        const productTypes = response.data.data.map((item) => ({
          label: item.ProductTypeName,
          icon: homeCategoryIconMap[item.ProductTypeName?.toUpperCase()] ? (
            <img
              src={homeCategoryIconMap[item.ProductTypeName?.toUpperCase()]}
              alt={item.ProductTypeName}
              style={{ width: 22, height: 22 }}
            />
          ) : (
            iconMap[item.ProductTypeName] || <DiamondIcon />
          ),
        }));
        
        // Optimized sorting with Map lookup
        const sortedProductTypes = productTypes.sort((a, b) => {
          const aIndex = desiredOrder.get(a.label.toUpperCase());
          const bIndex = desiredOrder.get(b.label.toUpperCase());
          
          // If both are in the desired order, sort by their position
          if (aIndex !== undefined && bIndex !== undefined) {
            return aIndex - bIndex;
          }
          // If only a is in the desired order, put it first
          if (aIndex !== undefined) {
            return -1;
          }
          // If only b is in the desired order, put it first
          if (bIndex !== undefined) {
            return 1;
          }
          // If neither is in the desired order, keep original order
          return 0;
        });
        
        setSidebarItems(sortedProductTypes);
        
        // Set the first item as selected and fetch its column items
        if (sortedProductTypes.length > 0) {
          setSelectedSidebar(0);
          // Use setTimeout to prevent blocking the UI
          setTimeout(() => {
            fetchColumnItems(sortedProductTypes[0].label);
          }, 0);
        }
      } else {
        console.error("Failed to fetch product types:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching product types:", error);
    }
  };

  // Fetch column items (Product SubTypes) based on ProductTypeName
  const fetchColumnItems = async (productTypeName) => {
    try {
      // Add loading state to prevent multiple calls
      if (!productTypeName) return;
      
      const response = await AxiosInstance.get(
        `${baseUrl}/productsubtype/getproductsubtypeallnames`,
        {
          params: { productTypeName },
        }
      );
      if (response.data.message === "Product SubTypes retrieved successfully") {
        const subTypes = response.data.data.map(
          (item) => item.ProductSubTypeName
        );
        setColumnItems([
          {
            image: imageMap[productTypeName] || broochesImg,
            title: productTypeName.toUpperCase(),
            items: subTypes,
            viewAll: "#",
          },
        ]);
      } else {
        console.error(
          "Failed to fetch product subtypes:",
          response.data.message
        );
        setColumnItems([]);
      }
    } catch (error) {
      console.error("Error fetching product subtypes:", error);
      setColumnItems([]);
    }
  };

  // Fetch sidebar items on component mount
  useEffect(() => {
    fetchSidebarItems();
  }, []);

  // Handle sidebar item click with debouncing
  const [isLoadingColumn, setIsLoadingColumn] = useState(false);
  
  const handleSidebarClick = (idx, productTypeName) => {
    if (isLoadingColumn) return; // Prevent rapid clicking
    
    setSelectedSidebar(idx);
    setIsLoadingColumn(true);
    
    fetchColumnItems(productTypeName).finally(() => {
      setIsLoadingColumn(false);
    });
  };

  return (
    <header className="header-top">
      <div className="container">
        <div className="header">
          <div className="logo">
            <img
              src={logo}
              alt="JPS Jewels"
              className="logo-image"
              onClick={() => navigate("/")}
            />
          </div>
          <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
            <Link
              to="/"
              className={`nav-link ${
                location.pathname === "/" ? "active" : ""
              }`}
              onClick={() => setMenuOpen(false)}
            >
              HOME
            </Link>

            {/* Responsive Jewellery Menu */}
            {isMobile ? (
              <div>
                <span
                  className={`nav-link jewellery-nav-link${
                    mobileJewelleryOpen ||
                    location.pathname.startsWith("/jewellery")
                      ? " jewellery-nav-link-active"
                      : ""
                  }`}
                  onClick={() => setMobileJewelleryOpen(!mobileJewelleryOpen)}
                  style={{ userSelect: "none" }}
                >
                  <JewelleryNavIcon />
                  Jewellery
                  <KeyboardArrowDownIcon
                    className={`jewellery-nav-link__arrow${
                      mobileJewelleryOpen ? " open" : ""
                    }`}
                    style={{ marginLeft: 2, transition: "transform 0.2s" }}
                  />
                </span>
                {mobileJewelleryOpen && (
                  <div className="mobile-jewellery-menu">
                    {sidebarItems.map((item, idx) => (
                      <div key={item.label}>
                        <div
                          className={`mobile-jewellery-menu-type${
                            columnItems.length > 0 &&
                            columnItems[0].title === item.label.toUpperCase()
                              ? " selected"
                              : ""
                          }`}
                          onClick={() => fetchColumnItems(item.label)}
                        >
                          {item.icon} {item.label}
                        </div>
                        {/* Only show subtypes for the selected type */}
                        {columnItems.length > 0 &&
                          columnItems[0].title === item.label.toUpperCase() && (
                            <>
                              <div className="mobile-jewellery-menu-section-header">
                                {columnItems[0].title}
                              </div>
                              <div className="mobile-jewellery-menu-subtypes">
                                {columnItems[0].items.map((subtype) => (
                                  <div
                                    key={subtype}
                                    className="mobile-jewellery-menu-subtype"
                                    onClick={(e) => {
                                      handleJewelleryItemClick(
                                        e,
                                        item.label,
                                        subtype
                                      );
                                      setMobileJewelleryOpen(false);
                                      setMenuOpen(false);
                                    }}
                                  >
                                    {subtype}
                                  </div>
                                ))}
                              </div>
                              <div className="mobile-jewellery-menu-divider"></div>
                            </>
                          )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div
                className="jewellery-nav-link-hover-area"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{ display: "inline-block", position: "relative" }}
              >
                <span
                  className={`nav-link jewellery-nav-link${
                    jewelleryMenuOpen ||
                    location.pathname.startsWith("/jewellery")
                      ? " jewellery-nav-link-active"
                      : ""
                  }`}
                  style={{ userSelect: "none" }}
                >
                  <JewelleryNavIcon />
                  Jewellery
                  <KeyboardArrowDownIcon
                    className={`jewellery-nav-link__arrow${
                      jewelleryMenuOpen ? " open" : ""
                    }`}
                    style={{ marginLeft: 2, transition: "transform 0.2s" }}
                  />
                </span>
                {jewelleryMenuOpen && (
                  <div
                    className="jewellery-mega-menu open"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div className="jewellery-mega-menu__sidebar">
                      <div className="jewellery-mega-menu__sidebar-header">
                        <JewelleryNavIcon style={{ marginRight: 10 }} />
                        <span>Jewellery</span>
                      </div>
                      <div className="jewellery-mega-menu__sidebar-list">
                        {sidebarItems.map((item, idx) => (
                          <div
                            key={item.label}
                            className={`jewellery-mega-menu__sidebar-item${
                              selectedSidebar === idx ? " active" : ""
                            }`}
                            onClick={() => handleSidebarClick(idx, item.label)}
                          >
                            {item.icon} {item.label}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="jewellery-mega-menu__content">
                      {columnItems.length > 0 && (
                        <div className="jewellery-mega-menu__column jewellery-mega-menu__column--active">
                          <img
                            src={columnItems[0].image}
                            alt={columnItems[0].title}
                            className="jewellery-mega-menu__column-img"
                          />
                          <div className="jewellery-mega-menu__column-content">
                            <div className="jewellery-mega-menu__title">
                              {columnItems[0].title}
                            </div>
                            {columnItems[0].items.map((item) => (
                              <a
                                href="#"
                                className="jewellery-mega-menu__item"
                                key={item}
                                onClick={(e) =>
                                  handleJewelleryItemClick(
                                    e,
                                    columnItems[0].title,
                                    item
                                  )
                                }
                              >
                                {item}
                              </a>
                            ))}
                            {/* <a
                              href={columnItems[0].viewAll}
                              className="jewellery-mega-menu__viewall"
                              onClick={(e) => e.preventDefault()}
                            >
                              View all
                            </a> */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            <div
              className={`nav-link diamond-nav-link${location.pathname === "/diamond" ? " active" : ""}`}
              style={{ cursor: "pointer", display: "inline-block" }}
              onClick={() => {
                setMenuOpen(false);
                // Clear any existing filter token to ensure clean diamond page
                localStorage.removeItem("filterToken");
                // Clear only the specific jewellery state, preserve Tawk.to and other important data
                try {
                  sessionStorage.removeItem("jewelleryToShopState");
                } catch (error) {
                  console.log("Could not clear jewellery state:", error);
                }
                navigate("/diamond?q=filter", { state: { fromJewellery: false } });
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <DiamondIcon
                  className="jewellery-nav-link__icon"
                  style={{ marginLeft: 6, fontSize: 18, color: "#C9A236" }}
                />
                &nbsp;DIAMOND
              </span>
            </div>
            <Link
              to="/aboutus"
              className={`nav-link ${
                location.pathname === "/aboutus" ? "active" : ""
              }`}
              onClick={() => setMenuOpen(false)}
            >
              ABOUT US
            </Link>
            <Link
              to="/contactus"
              className={`nav-link ${
                location.pathname === "/contactus" ? "active" : ""
              }`}
              onClick={() => setMenuOpen(false)}
            >
              CONTACT US
            </Link>
          </nav>
          <div className="right-section">
            <div className="icons">
              <ClickAwayListener onClickAway={() => setSearchOpen(false)}>
                <div className="user-login-container">
                  <IconButton
                    className="cart-button"
                    color="inherit"
                    onClick={() => setSearchOpen(!searchOpen)}
                  >
                    <SearchIcon fontSize="small" />
                  </IconButton>
                  {searchOpen && (
                    <div className="login-dropdown">
                      <IconButton
                        className="cart-button"
                        color="inherit"
                        onClick={() => setSearchOpen(false)}
                        style={{ position: "absolute", top: 5, right: 5 }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                      <form onSubmit={searchFormik.handleSubmit}>
                        <FormGroup
                          className="text-boxes"
                          style={{ width: "100%", marginTop: "24px" }}
                        >
                          <TextField
                            value={searchFormik.values.CertificateNo}
                            onBlur={searchFormik.handleBlur}
                            onChange={handleInput}
                            onKeyDown={handleKeyPress}
                            error={
                              searchFormik.touched.CertificateNo &&
                              Boolean(searchFormik.errors.CertificateNo)
                            }
                            helperText={
                              searchFormik.touched.CertificateNo &&
                              searchFormik.errors.CertificateNo
                            }
                            name="CertificateNo"
                            label="Search"
                            placeholder="Search by Stock Id number or by Product Name"
                            type="text"
                            className="custom-textfield w-100"
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                              style: { color: "#666" },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": { borderColor: "#ccc" },
                                "&:hover fieldset": { borderColor: "#999" },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#ccc",
                                },
                              },
                            }}
                          />
                        </FormGroup>
                      </form>
                    </div>
                  )}
                </div>
              </ClickAwayListener>
              <div className="cart-icon-container">
                <IconButton
                  color="inherit"
                  onClick={() => setCartOpen(true)}
                  className="cart-button"
                >
                  <Badge badgeContent={cartCount || 0} color="error">
                    <ShoppingCartIcon fontSize="small" />
                  </Badge>
                </IconButton>
              </div>
              <Drawer
                anchor="right"
                open={cartopen}
                onClose={() => setCartOpen(false)}
              >
                <Box
                  className="cart-drawer"
                  sx={{
                    width: 400,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    padding: 2,
                    position: "relative",
                  }}
                >
                  <IconButton
                    className="closeicon"
                    onClick={() => setCartOpen(false)}
                    sx={{ position: "absolute", top: 10, right: 10 }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography
                    variant="h6"
                    sx={{ marginBottom: 2, textAlign: "left" }}
                  >
                    CART
                  </Typography>
                  <div style={{ height: "100%", overflowY: "auto" }}>
                    {cartData && cartData.length > 0 ? (
                        cartData.map((item, index) => (
                          <div
                            key={item.AddToCartId}
                            style={{
                              marginBottom: "20px",
                              border: "1px solid #ddd",
                              borderRadius: "10px",
                              padding: "10px",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* <div
                              className="widget_shopping_cart_content"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                textAlign: "left",
                              }}
                            >
                              <div>
                                <img
                                  className="ImagessElement"
                                  src={item?.diamondDetails?.Image}
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    borderRadius: "10px",
                                  }}
                                />
                              </div>
                              <div style={{ marginLeft: "15px" }}>
                                <span>
                                  <span>
                                    {item?.diamondDetails?.Carats || ""}
                                  </span>{" "}
                                  Carat{" "}
                                  <span>{item?.diamondDetails?.Shape}</span>{" "}
                                  <span>{item?.diamondDetails?.Color}</span>/
                                  <span>{item?.diamondDetails?.Clarity}</span> -{" "}
                                  <span>{item?.diamondDetails?.Lab}</span>{" "}
                                  <span>{item?.diamondDetails?.Cut}</span>
                                </span>
                                <div
                                  style={{ display: "flex", marginTop: "0" }}
                                >
                                  <span>
                                    Quantity: <span>{item?.Quantity}</span> x{" "}
                                    {item?.diamondDetails?.Amount}
                                  </span>
                                </div>
                              </div>
                            </div> */}
                            <div
                              className="widget_shopping_cart_content"
                              style={{
                                display: "flex",
                                flexDirection: "column", // Changed to column for better separation
                                textAlign: "left",
                                width: "100%",
                              }}
                            >
                              {/* Jewellery Details */}
                              {item?.jewelleryParent && item?.matchedChild && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div>
                                    <img
                                      className="ImagessElement"
                                      src={
                                        (item?.matchedChild?.images &&
                                          item?.matchedChild?.images[0]) ||
                                        "https://via.placeholder.com/70"
                                      }
                                      alt={
                                        item?.jewelleryParent?.ProductName ||
                                        "Jewellery"
                                      }
                                      style={{
                                        width: "70px",
                                        height: "70px",
                                        borderRadius: "10px",
                                        border: "1px solid #ddd",
                                      }}
                                    />
                                  </div>
                                  <div style={{ marginLeft: "15px" }}>
                                    <Typography
                                      variant="subtitle1"
                                      style={{ fontWeight: 600 }}
                                    >
                                      {item?.jewelleryParent?.ProductName ||
                                        "Unnamed Jewellery"}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Type:</strong>{" "}
                                      {item?.jewelleryParent?.ProductTypeName ||
                                        "N/A"}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Sub-Type:</strong>{" "}
                                      {item?.jewelleryParent
                                        ?.ProductSubTypeName || "N/A"}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Metal:</strong>{" "}
                                      {item?.matchedChild?.karat || "N/A"}{" "}
                                      {item?.matchedChild?.goldType || "N/A"}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Shape:</strong>{" "}
                                      {(
                                        item?.matchedChild?.diamondShapes || []
                                      ).join(", ") || "N/A"}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Price:</strong>{" "}
                                      {(() => {
                                        const basePrice = item?.jewellaryAmount
                                          ? parseFloat(item.jewellaryAmount)
                                          : 0;
                                        const customFields = Array.isArray(
                                          item?.customFields
                                        )
                                          ? item.customFields
                                          : [];
                                        const customFieldsWithAmount =
                                          customFields.filter(
                                            (f) =>
                                              f.amount && Number(f.amount) > 0
                                          );
                                        if (customFieldsWithAmount.length > 0) {
                                          const customTotal =
                                            customFieldsWithAmount.reduce(
                                              (sum, f) =>
                                                sum + Number(f.amount),
                                              0
                                            );
                                          const breakdown =
                                            customFieldsWithAmount
                                              .map(
                                                (f) =>
                                                  `$${Number(f.amount).toFixed(
                                                    2
                                                  )} (${f.label})`
                                              )
                                              .join(" + ");
                                          return (
                                            <>
                                              ${basePrice.toFixed(2)} +{" "}
                                              {breakdown} ={" "}
                                              <b>
                                                $
                                                {(
                                                  basePrice + customTotal
                                                ).toFixed(2)}
                                              </b>
                                            </>
                                          );
                                        } else if (basePrice > 0) {
                                          return `$${basePrice.toFixed(2)}`;
                                        } else {
                                          return "Price not available";
                                        }
                                      })()}
                                    </Typography>
                                  </div>
                                </div>
                              )}
                              {/* Diamond Details */}
                              {item?.diamondDetails && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <img
                                      className="ImagessElement"
                                      src={
                                        item?.diamondDetails?.Image ||
                                        "https://via.placeholder.com/70"
                                      }
                                      alt={
                                        item?.diamondDetails?.Shape || "Diamond"
                                      }
                                      style={{
                                        width: "70px",
                                        height: "70px",
                                        borderRadius: "10px",
                                      }}
                                    />
                                  </div>
                                  <div style={{ marginLeft: "15px" }}>
                                    <Typography variant="subtitle2">
                                      <span>
                                        {item?.diamondDetails?.Carats || ""}
                                      </span>{" "}
                                      Carat{" "}
                                      <span>
                                        {item?.diamondDetails?.Shape || ""}
                                      </span>{" "}
                                      <span>
                                        {item?.diamondDetails?.Color || "N/A"}
                                      </span>
                                      /
                                      <span>
                                        {item?.diamondDetails?.Clarity || "N/A"}
                                      </span>{" "}
                                      -{" "}
                                      <span>
                                        {item?.diamondDetails?.Lab || "N/A"}
                                      </span>{" "}
                                      <span>
                                        {item?.diamondDetails?.Cut || "N/A"}
                                      </span>
                                    </Typography>
                                    <div
                                      style={{
                                        display: "flex",
                                        marginTop: "0",
                                      }}
                                    >
                                      <Typography variant="body2">
                                        <strong>Quantity:</strong>{" "}
                                        <span>{item?.Quantity || 1}</span> x $
                                        {item?.diamondDetails?.Amount?.toFixed(
                                          2
                                        ) || "0.00"}
                                      </Typography>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{
                                color: "#C9A236",
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                dispatch(
                                  removeFromCart(
                                    item.AddToCartId,
                                    id,
                                    id,
                                    navigate
                                  )
                                );
                              }}
                            />
                          </div>
                        ))
                      ) : (
                        <p>No items in the cart</p>
                    )}
                  </div>
                  {cartData && cartData.length > 0 && (
                  <div className="header-checkout mb-3">
                    <span> Total:</span>
                    <span>{`$ ${cartTotal?.toFixed(2)}`}</span>
                  </div>
                  )}
                  <Button
                    className="checkoutbutton"
                    variant="contained"
                    disabled={!cartData || cartData.length === 0}
                    sx={{ 
                      marginTop: "auto", 
                      backgroundColor: (!cartData || cartData.length === 0) ? "#ccc" : "#C9A236",
                      "&:disabled": {
                        backgroundColor: "#ccc",
                        color: "#666"
                      }
                    }}
                    onClick={() => {
                      navigate("/checkout");
                      setCartOpen(false);
                    }}
                  >
                    Checkout
                  </Button>
                </Box>
              </Drawer>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <div className="user-login-container">
                  <IconButton
                    className="cart-button"
                    color="inherit"
                    onClick={() => {
                      if (window.innerWidth <= 768) {
                        if (userNames) {
                          navigate("/profile");
                        } else {
                          navigate("/login");
                        }
                      } else {
                        setOpen(!open);
                      }
                    }}
                  >
                    <PersonOutlineIcon />
                  </IconButton>
                  {open && userNames && (
                    <div className="user-drawer-container">
                      <div className="user-profile-header">
                        <div
                          style={{
                            borderRadius: "50%",
                            width: "40px",
                            fontSize: "25px",
                            fontWeight: "600",
                            backgroundColor: "white",
                            color: "#c9a236",
                          }}
                        >
                          {`${userNames?.slice(0, 1).toUpperCase()}`}
                        </div>
                        <div className="p-2" style={{ cursor: "default" }}>
                          <div className="user-name">{userNames}</div>
                          <div className="user-email">{Mails}</div>
                        </div>
                      </div>
                      <div
                        className="user-menu-item"
                        onClick={() => {
                          navigate("/profile");
                          setOpen(false);
                        }}
                      >
                        <PersonOutlineIcon className="user-menu-icon" />
                        <span>Profile</span>
                      </div>
                      <div
                        className="user-menu-item"
                        onClick={() => {
                          navigate("/dashboard");
                          setOpen(false);
                        }}
                      >
                        <DashboardIcon className="user-menu-icon" />
                        <span>Dashboard</span>
                      </div>
                      <div
                        className="user-menu-item"
                        onClick={() => {
                          navigate("/orderhistory");
                          setOpen(false);
                        }}
                      >
                        <ReceiptLongIcon className="user-menu-icon" />
                        <span>Order history</span>
                      </div>
                      <div
                        className="user-menu-item"
                        onClick={() => {
                          navigate("/activitylog");
                          setOpen(false);
                        }}
                      >
                        <HistoryIcon className="user-menu-icon" />
                        <span>Activity Log</span>
                      </div>
                      <div
                        className="user-menu-item logout"
                        onClick={() => {
                          localStorage.clear();
                          formik.resetForm();
                          setOpen(false);
                          handleLogout();
                        }}
                      >
                        <LogoutIcon className="user-menu-icon" />
                        <span>Log out</span>
                      </div>
                    </div>
                  )}
                  {open && !userNames && (
                    <div CSF className="login-dropdown">
                      <form onSubmit={formik.handleSubmit}>
                        <FormGroup style={{ width: "100%", marginTop: "24px" }}>
                          <TextField
                            value={formik.values.Username}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.Username &&
                              Boolean(formik.errors.Username)
                            }
                            helperText={
                              formik.touched.Username && formik.errors.Username
                            }
                            name="Username"
                            label="Username"
                            type="text"
                            fullWidth
                          />
                        </FormGroup>
                        <div className="password-container">
                          <TextField
                            value={formik.values.UserPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="UserPassword"
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    style={{ outline: "none" }}
                                    aria-label="toggle password visibility"
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                    edge="end"
                                  >
                                    {showPassword ? (
                                      <VisibilityIcon />
                                    ) : (
                                      <VisibilityOffIcon />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            error={
                              formik.touched.UserPassword &&
                              Boolean(formik.errors.UserPassword)
                            }
                            helperText={
                              formik.touched.UserPassword &&
                              formik.errors.UserPassword
                            }
                          />
                        </div>
                        <Button
                          type="submit"
                          variant="contained"
                          className="login-btn-login"
                          disabled={loader}
                        >
                          {loader ? (
                            <WhiteLoader
                              height="30"
                              width="30"
                              padding="10px"
                              loader={loader}
                            />
                          ) : (
                            "Login"
                          )}
                        </Button>
                        <p className="forgot-signup">
                          <span
                            className="signup-link-signup"
                            onClick={() => {
                              navigate("/signup");
                              setOpen(false);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Sign up
                          </span>
                        </p>
                      </form>
                    </div>
                  )}
                </div>
              </ClickAwayListener>
            </div>
            <div className="mobile-menu" onClick={toggleMenu}>
              <i
                className={`fa-solid ${menuOpen ? "fa-times" : "fa-bars"}`}
              ></i>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
